import React from 'react';
import { ButtonSize } from 'components/Button/Button';
import Modal from 'components/Modal';
import { useSocialSharePlatform } from 'containers/SocialShareModal/SocialSharePlatforms/SocialSharePlatformContext';
import useIsBlockingActionInProgress from '../useIsBlockingActionInProgress';

export type SocialShareModalFooterAuthButtonProps = {
  size?: ButtonSize;
  children?: React.ReactNode;
};

const SocialShareModalFooterAuthButton: React.FC<SocialShareModalFooterAuthButtonProps> = ({
  size,
  children,
}) => {
  const { authenticate } = useSocialSharePlatform();
  const isBlockingActionInProgress = useIsBlockingActionInProgress();

  return (
    <Modal.FooterButton
      theme="submit"
      size={size}
      disabled={isBlockingActionInProgress}
      onClick={authenticate}
    >
      {children}
    </Modal.FooterButton>
  );
};

export default SocialShareModalFooterAuthButton;
